import { GiFactory } from "react-icons/gi";
import "./PlaceholderImage.css";

/**
 * Stand-in for real photography. Replace by dropping optimized WebP
 * files into src/assets/images and swapping this component for an
 * <img> tag — the `tone` prop maps to a numbered gradient so visuals
 * stay varied until real photos are added.
 */
export default function PlaceholderImage({ tone = "1", alt = "", className = "", ratio = "4/5" }) {
  return (
    <div
      className={`ph-image ph-image--tone-${tone} ${className}`}
      style={{ aspectRatio: ratio }}
      role="img"
      aria-label={alt}
    >
      <div className="ph-image__grid" aria-hidden="true" />
      <GiFactory className="ph-image__icon" aria-hidden="true" />
    </div>
  );
}
